export default "__VITE_ASSET__DfXfPzB5__"